<template>
  <div class="privacy-policy">
    <section-header tag="h1" class="mt-5 mb-5" title="隱私權政策" subtitle="Privacy Policy"/>
    <section>
      <p>保護消費者的個人隱私是 Loft29 Collection (浩境國際有限公司)重要的經營理念,我們清楚的了解客戶是企業最重要的資產,在未經消費者同意之下,我們絕不會將您的個人資料提供予任何與本購物網站服務無關之第三人。Loft29 Collection提供線上購物的交易服務為確保僅為履行訂單及行銷之目的使用消費者提供的所有資料,特別制定如下隱私權保護條款。</p>
    </section>
    <section class="mt-5">
      <collapse-item v-for="(item, index) in context" :id="item.id" :title="item.title" :content="item.content" :key="index"/>
      <div class="border-top border-dark"></div>
    </section>
    <section class="mt-5">
      <div>隱私權保護政策之修訂</div>
      <div>Loft29 Collection保有修訂本條款之權利,如條款內容有更動,我們將明列在【會員專區】的頁面通知您。</div>
      <div>若您對於Loft29 Collection所提供之隱私權保護條款有任何問題,請來信至info@collection.com.tw。</div>
    </section>
  </div>
</template>

<script>
import SectionHeader from '@/components/SectionHeader.vue'
import CollapseItem from '@/components/CollapseItem.vue'

export default {
  name: 'PrivacyPolicy',
  components: {
    SectionHeader,
    CollapseItem
  },
  data: function () {
    return {
      context: [
        {
          id: 'scope',
          title: '隱私權保護條款適用範圍',
          content: [
            '隱私權保護條款內容包括Loft29 Collection於會員使用網站服務時收集到的身份識別與購物資訊。'
          ]
        },
        {
          id: 'person-info',
          title: '個人資料收集與使用',
          content: [
            '一般瀏覽Loft29 collection並不需要輸入個人資料。當您購物結帳時,Loft29 collection才會請您註冊/登錄會員,並請您提供包括訂購人及收件人之姓名、住址、聯絡電話、E-mail 等詳細資料,以做為宅配業者送貨、客戶服務、行銷服務之需要。未經您的同意,Loft29 Collection不會擅自將您的個人資料提供作購物以外之其他用途。',
            'Loft29 Collection自動收集一些使用行為資料,做為行銷分析使用,目的是了解客戶的喜好,提供您更貼切的服務。這類資料包括:客戶所做的產品搜尋字串、商品與頁面點閱次數、上站時間、停留時間等,但此類資料僅屬於總量分析,不針對特定人或特定 IP 做單獨追蹤。',
            'Loft29 Collection將不定期地寄送電子報或活動訊息至您的E-mail信箱,如需取消訂閱電子報,您可以E-mail或電話告知我們。'
          ]
        },
        {
          id: 'protection',
          title: '自我保護措施',
          content: [
            '請您妥善保管您的會員密碼及登入資料,不要將任何個人資料,尤其是密碼提供給任何人。',
            '您可使用Loft29 Collection網站頁面右上方的【會員專區】修改您的個人資料。如果您忘記了會員密碼,您可以點選【忘記密碼】選項並輸入加入會員時所使用的 E-mail 信箱獲得您的密碼,即使是Loft29 Collection的人員也無法得知您的會員密碼,藉此保障您的購物隱私。',
            '請您於完成購物後,做出會員登出的動作。假如您是與他人共用電腦或使用公共電腦,務必要關閉瀏覽器視窗,以保障您的購物隱私。'
          ]
        },
        {
          id: 'transaction',
          title: '網路交易安全',
          content: [
            '為保障您的購物隱私及安全,您的帳號及交易資料使用密碼保護,同時,為了保護使用者個人隱私,我們無法為您查詢其他會員的交易及帳號資料,請您見諒!',
            'Loft29 Collection 為確保您的電子交易安全,嚴選全台第一家接受 VISA 國際組織駐點稽核的第三方金流服務業者、兩度榮獲經濟部商業司認定為電子商務交易履約保障機制的示範廠商-『藍新科技專業版線上金流」,刷卡資料將採用 Entrust 128bits SSL 電子安全機制將刷卡資料加密並直接與銀行連線傳輸,Loft29 Collection 網站本身不儲存任何卡號資訊;同時由 VISA提供的Verified By VISA 3D Secure (VBV) 加密安全驗證機制與 Master 國際信用卡組織SecureCode、CVC2 (末三碼驗證) 安全認證機制透過持卡人向銀行申請刷卡密碼,透過這一層驗證程序更能確保卡片持有人的用卡安全。'
          ]
        }
      ]
    }
  }
}
</script>

<style scoped>
</style>
